export const NODE_TRANSFORM_DIRTY: any = 'nodetransformdirty';
export const TRANSFORM_DIRTY: any = 'transformdirty';
